import { dbService, STORE_CRONOGRAMA } from './indexeddb';
import { CronogramaTaskResponse } from '@/services/api';

export interface CronogramaCache {
    id: string; // projetoId
    tarefas: CronogramaTaskResponse[];
    atualizadoEm: string;
}

export class CronogramaRepository {
    async saveTasks(projetoId: string, tarefas: CronogramaTaskResponse[]): Promise<void> {
        const record: CronogramaCache = {
            id: projetoId,
            tarefas,
            atualizadoEm: new Date().toISOString()
        };
        await dbService.put(STORE_CRONOGRAMA, record);
    }

    async getTasks(projetoId: string): Promise<CronogramaTaskResponse[] | null> {
        const record = await dbService.get<CronogramaCache>(STORE_CRONOGRAMA, projetoId);
        return record ? record.tarefas : null;
    }
}

export const cronogramaRepository = new CronogramaRepository();
